<template>
  <div class="journal-view">
    <v-row>
      <v-col cols="7"></v-col>
      <v-col cols="5" class="example-height">
        <JournalComponent :entries="journalEntries" @newEntry="newEntry" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {ref} from '@vue/composition-api'

import JournalComponent from "@/components/lead/journal/JournalComponent";

export default {
  name: "JournalView",
  components: {JournalComponent},
  setup() {
    const journalEntries = ref([
      {
        name: 'Andre 5024',
        type: 'appointment',
        timestamp: Date.now(),
        image: 'https://picsum.photos/48?random=1',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5025',
        type: 'phoneCall',
        timestamp: Date.now() - 30000,
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5026',
        type: 'text',
        timestamp: Date.now() - 3500000,
        image: 'https://picsum.photos/48?random=3',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5027',
        type: 'text',
        timestamp: Date.now() - 3600000,
        image: 'https://picsum.photos/48?random=4',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5028',
        type: 'text',
        timestamp: Date.now() - 86400000,
        image: 'https://picsum.photos/48?random=5',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5029',
        type: 'phoneCall',
        timestamp: Date.now() - 30000,
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5030',
        type: 'text',
        timestamp: Date.now() - 3500000,
        image: 'https://picsum.photos/48?random=3',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5031',
        type: 'text',
        timestamp: Date.now() - 3600000,
        image: 'https://picsum.photos/48?random=4',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      },
      {
        name: 'Andre 5032',
        type: 'text',
        timestamp: Date.now() - 86400000,
        image: 'https://picsum.photos/48?random=5',
        content: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum.'
      }
    ])

    function newEntry(entryContent) {
      const newEntryTemplate = {
        name: 'Current Username',
        type: 'text',
        timestamp: Date.now(),
        content: entryContent
      }
      journalEntries.value.unshift(newEntryTemplate)
    }
    return {journalEntries, newEntry}
  }
}
</script>

<style scoped>
.example-height {
  max-height: 600px;
}
</style>
